export default __webpack_public_path__ + "static/media/drive.a5bbfcfc.svg";